module.exports = __webpack_public_path__ + "static/media/mira_old_UI_transparent.ecd05465.png";